'use client';

import { ReactNode, useEffect, useState, startTransition } from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@workspace/ui/components/dropdown-menu';
import { Icon } from './Icon';
import { logout } from '@/src/actions/auth';
import { useRouter, usePathname } from 'next/navigation';
import { resetUser } from '@/src/lib/analytics/posthog';

export const ProfileOptions = ({
  children,
  profileLink,
}: {
  children: ReactNode;
  profileLink: string;
}) => {
  const router = useRouter();
  const pathname = usePathname();

  const [isNavigating, setIsNavigating] = useState(false);
  const [targetPath, setTargetPath] = useState<string | null>(null);

  useEffect(() => {
    if (!isNavigating) return;
    if (targetPath && pathname === targetPath) {
      setIsNavigating(false);
      setTargetPath(null);
    }
  }, [pathname, isNavigating, targetPath]);

  const go = (to: string) => {
    setIsNavigating(true);
    setTargetPath(to);
    startTransition(() => {
      router.push(to);
    });
  };

  const handleLogout = async () => {
    resetUser();
    await logout();

  };

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild className="p-0! md:p-4!">
        {children}
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end" className="space-y-2">
        <DropdownMenuItem
          className="flex items-center gap-2.5 py-1 text-sm font-medium hover:cursor-pointer"
          onClick={() => go(`/${profileLink}`)}
          disabled={isNavigating}
        >
          <Icon name="profile" className="size-4" />
          <span className="flex items-center gap-2">My Profile</span>
        </DropdownMenuItem>

        <DropdownMenuItem
          className="flex items-center gap-2.5 py-1 text-sm font-medium hover:cursor-pointer"
          onClick={() => go('/settings')}
          disabled={isNavigating}
        >
          <Icon name="settings" className="size-4" />
          <span className="flex items-center gap-2">Profile settings</span>
        </DropdownMenuItem>

        <DropdownMenuSeparator className="mx-0.5" />

        <DropdownMenuItem
          className="flex items-center gap-2.5 py-2 text-sm font-medium hover:cursor-pointer"
          onClick={handleLogout}
          disabled={isNavigating}
        >
          <Icon name="logout" className="size-4" />
          <span>Log out</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
